<div>
  <div class="center-div">
    <button mat-raised-button class="mat-elevation-z5" (click)="go()">
      <img style="margin:auto" mat-card-image src="../../../assets/{{image}}">
    </button>
    <div style="padding-top: 15px">
      <span style="font-size: 15px"><strong>{{title}}</strong></span>
    </div>
  </div>
</div>
